<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import 'element-ui/lib/theme-chalk/index.css'
  import './common/css/reset.css'
  import './common/css/main.css'
export default {
  name: 'App'
}
</script>

<style lang="less">
 /*@import './common/css/template.less';*/
</style>



// WEBPACK FOOTER //
// src/App.vue